// USER SUBSCRIPTION CLOSE REQUEST ****************************************************************
// pathname: /v1/user-subscription/payment-details
// ************************************************************************************************
import {
  useSwrApi,
  ApiUserSubscriptionPaymentDetailsOk,
  ApiUserSubscriptionPaymentDetails,
} from 'src/hooks/useSwrApi';


// Interface
// ******************************************
interface UseSwrPaymentDetails {
  locale?: string,
  urlParams?: string,
  serverSideData?: ApiUserSubscriptionPaymentDetails,
  shouldFetch?: boolean,
}


/**
 * @description SWR: get payment details for user subscription
 *
 * Props:
 * - **locale** - the locale to use for the request.
 * - **urlParams** - the url params to use for the request.
 * - **serverSideData** - the data we got from the server side request (if we do it).
 * - **shouldFetch** - condition for fetching the data.
 */
export const useSwrPaymentDetails = (props: UseSwrPaymentDetails) => {
  // Destructure props
  const {
    locale = 'ro',
    urlParams = '',
    serverSideData,
    shouldFetch = true,
  } = props;

  // Get data from API
  const {
    data, error, mutate, isValidating, isLoading, mutateSiblings,
  } = useSwrApi<ApiUserSubscriptionPaymentDetailsOk>({
    url: '/v1/user-subscription/payment-details',
    urlParams,
    locale,
    serverSideData,
    shouldFetch,
  });

  // return data
  return {
    data,
    error,
    mutate,
    mutateSiblings,
    isValidating,
    isLoading,
  };
};
